import PropTypes from 'prop-types';
import { commonPropTypes, } from '../../interfaces/commonProps';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export const tabSizes = [
    'small',
    'large',
];
export const navVariants = ['text', 'tabs'];
export const scrollControlPosition = [
    'start',
    'end',
];
export const scrollButtonOptions = ['always', 'never', 'auto'];
export const listPropTypes = {
    size: PropTypes.oneOf(tabSizes),
    variant: PropTypes.oneOf(navVariants),
    selectionFollowsFocus: PropTypes.bool,
    ...commonPropTypes,
    ...spacingPropTypes,
};
export const itemPropTypes = {
    id: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};
//# sourceMappingURL=GenericNavigation.types.js.map